var path = './file-browser/dropDownFolderDownloadDisabledTooltip.html';
var html = "<div ng-bind-html=\"getDownloadDisabledReason() !== null ? getDownloadDisabledReason() : ('FILE_ACTIONS.DOWNLOAD'|translate)\" ng-click=\"markCompanionAsInstalled()\"></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;